import { render, staticRenderFns } from "./IdenfityTesting.vue?vue&type=template&id=206b8b60&scoped=true"
import script from "./IdenfityTesting.vue?vue&type=script&lang=js"
export * from "./IdenfityTesting.vue?vue&type=script&lang=js"
import style0 from "./IdenfityTesting.vue?vue&type=style&index=0&id=206b8b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b8b60",
  null
  
)

export default component.exports